import get from 'lodash/get';
import { createSelector } from 'reselect';

const baseFiltersSettingsSelector = (state) => get(state, 'filters.settings', {});
export const getFilterSettingsSelector = (filterId) =>
  createSelector(baseFiltersSettingsSelector, (settings) => settings[filterId]);
